import React, { useState } from "react";
import { useEffect } from "react";

import useDeleteData from "../../../../customhooks/deletedata";

import { authJsonHeaders } from "../../../../constants";

function DeleteAddress(props) {
  const [deletedAddress, deleteAddressError, deleteAddress] = useDeleteData();

  const [animate, setAnimate] = useState({});

  useEffect(() => {
    setAnimate({
      transform: "translateY(0%)",
    });
  }, []);

  const handleClickDeleteAddress = () => {
    deleteAddress({
      url: `${process.env.REACT_APP_API_URL}/app/userAddress/${props.addressId}`,
      //headers: authJsonHeaders,
      headers: {
        "Content-type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
  };

  useEffect(() => {
    if (
      deletedAddress != undefined &&
      deletedAddress != null &&
      deletedAddress != ""
    ) {
      props.getAddress({
        url: `${
          process.env.REACT_APP_API_URL
        }/app/userAddress/search?user=${localStorage.getItem("userId")}`,
        //headers: authJsonHeaders,
        headers: {
          "Content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (props.fromParent) {

        const addressResRef = props.fromParent();

        addressResRef.then((res) => {
          if (res) {
            props.setUserAddress(res);
          }
        });
      }

      props.setIsDeleteAddress(false);
    }
  }, [deletedAddress]);

  const handleClickOnBack = () => {
    setAnimate({
      transform: "translateY(100%)",
    });
    setTimeout(() => {
      props.setIsDeleteAddress(false);
    }, 1000);
  };

  return (
    <div
      style={animate}
      className="delete-address-container d-flex justify-content-center align-items-center"
    >
      <div className="delete-address-section d-flex flex-column justify-content-center align-items-center">
        <p className="mb-0 message text-center">
          Are you sure you want to delete this address?
        </p>
        <div className="d-flex justify-content-between align-items-center w-100">
          <button
            onClick={() => {
              handleClickOnBack();
            }}
            className="no"
          >
            No
          </button>
          <button
            onClick={() => {
              handleClickDeleteAddress();
            }}
            className="yes"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteAddress;
